import BaseUseCase from "../../../base_use_case.js";

class SaveCountryUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/addresses/countries/${identifier}` : `/api/v1/admin/addresses/countries`;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: this.wrapParams(params, "country"),
    });
  }
}

const instance = new SaveCountryUseCase();
export default instance;